import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getAccessionSamples = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_ACCESSION_SAMPLES.METHOD](APIConfig.GET_ACCESSION_SAMPLES.URL, payload);
}

const approveSample = (sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.APPROVE_REJECT_SAMPLE.METHOD](APIConfig.APPROVE_REJECT_SAMPLE.URL(sampleId), payload,);
}

const rejectSample = (sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.APPROVE_REJECT_SAMPLE.METHOD](APIConfig.APPROVE_REJECT_SAMPLE.URL(sampleId), payload,
        {'Content-Type': 'multipart/form-data'});
}

const assignNewBarcode = (sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ASSIGN_NEW_BARCODE.METHOD](APIConfig.ASSIGN_NEW_BARCODE.URL(sampleId), payload);
}

const viewAttachments = (orderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VIEW_ATTACHMENTS.METHOD](APIConfig.VIEW_ATTACHMENTS.URL(orderId), payload);
}

const AccessioningService = {
    getAccessionSamples,
    approveSample,
    rejectSample,
    assignNewBarcode,
    viewAttachments
}

export default AccessioningService;